import axios from "@/axios.js"

export default {
  getAllPackages({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewTestPackages", data)
        .then((response) => {
          commit('SET_PACKAGES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAPackage({ commit }, packageId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/package/"+packageId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createPackage({ commit }, packageData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/package/create", packageData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updatePackage({ commit }, packageData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/package/"+packageData.id, packageData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
}
